import {
  LOAD_WORLD_PAY_REQUEST,
  LOAD_WORLD_PAY_SUCCESS,
  LOAD_WORLD_PAY_ERROR
} from "../actions/worldPayActions";

const initialState = {
  checkoutScript: {
    loading: false,
    error: false,
    loaded: false
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_WORLD_PAY_REQUEST:
      return {
        ...state,
        checkoutScript: {
          loading: true,
          error: false
        }
      };
    case LOAD_WORLD_PAY_SUCCESS:
      return {
        ...state,
        checkoutScript: {
          loading: false,
          loaded: true,
          error: false
        }
      };
    case LOAD_WORLD_PAY_ERROR:
      return {
        ...state,
        checkoutScript: {
          loading: false,
          error: true
        }
      };
    default:
      return state;
  }
};
export default {
  initialState,
  reducer
};
